import { SidebarService, SidebarServiceModule } from '@b2b/common/services/sidebar';
import { TODO, input } from '@b2b/types/core';
import angular from 'angular';
import { Subscription } from 'rxjs';
import { AdvancedFiltersService, AdvancedFiltersServiceModule } from './advanced-filters.service';
import { AdvancedFiltersVM } from './types';

class AdvancedFiltersTriggerController {
  static $inject = ['$element', 'HelpersService', 'AdvancedFiltersService', 'SidebarService'];

  name = input.required('');
  vm: AdvancedFiltersVM;
  subscription: Subscription;
  filterFields: TODO;
  labelsMap: TODO;
  isEmpty: TODO;
  selectedOperator: TODO;

  constructor(
    private $element: JQuery,
    private HelpersService: TODO,
    private advancedFiltersService: AdvancedFiltersService,
    private sidebarService: SidebarService
  ) {}

  $onInit() {
    this.$element.addClass('acme-advanced-filters-trigger');

    if (!this.name) {
      throw new Error('acmeAdvancedFiltersTrigger.name is required');
    }

    this.vm = this.advancedFiltersService.registerComponent({ name: this.name, triggerCtrl: this });
    this.updateState();

    this.subscription = this.vm.subject.subscribe({
      next: () => {
        this.updateState();
      },
    });
  }

  $onDestroy() {
    this.subscription?.unsubscribe();
  }

  isSidebarOpen() {
    return this.sidebarService.isShown;
  }

  toggle(event: TODO) {
    event.stopPropagation();
    this.sidebarService.toggle();
  }

  clearAllFilters() {
    this.advancedFiltersService.clearAllComponentFilters({ name: this.name, emitEvent: true });
  }

  clearFilter(filterField: TODO) {
    this.advancedFiltersService.clearComponentFilter({ name: this.name, filterName: filterField.name });
  }

  updateState() {
    const rawFilters = angular.copy(this.vm.model);
    this.filterFields = this.advancedFiltersService.mapRawFiltersToFieldsSearchParams(rawFilters);

    this.labelsMap = this.HelpersService.path(this.vm, ['filtersCtrl', 'fields'], []).reduce((result, field) => {
      if (field.value) {
        result[field.value] = field.label;
      }

      return result;
    }, {});

    this.isEmpty = this.filterFields.every((field) => {
      return field.values.length === 0;
    });

    this.selectedOperator = this.HelpersService.path(this.vm, ['filtersCtrl', 'selectedOperator', 'label'], 'AND');
  }

  disableField(field: TODO) {
    const fields = this.HelpersService.path(this.vm, ['filtersCtrl', 'fields'], []);
    const currentFiled = fields.find((currentFiled) => field.name === currentFiled.value);
    
    return currentFiled
      ? this.advancedFiltersService.disableField({ componentName: this.name, field: currentFiled })
      : false;
  }
}

export const AdvancedFiltersTriggerComponentModule = angular
  .module('acme.common.component.advancedFilters.trigger', [
    'acme.common.service.helpers',
    AdvancedFiltersServiceModule,
    SidebarServiceModule,
  ])
  .component('acmeAdvancedFiltersTrigger', {
    templateUrl: 'common/components/advanced-filters/advanced-filters-trigger.component.tpl.html',
    controller: AdvancedFiltersTriggerController,
    bindings: {
      name: '<',
    },
  }).name;
